import Konva from 'konva';

import { ANCHOR_STYLE } from './constants';

const isAnchor = (node: Konva.Node): boolean =>
  node.name() === ANCHOR_STYLE.name;

export default isAnchor;
